<template>
	<div>
		<div class="card" style="width: 12rem;">
			<img :src="img" class="card-img-top p-3" :alt="etiquetas">
			<div class="card-body">
				<h4 class="card-title text-center">{{nombre}}</h4>
				<p class="card-text text-center">Existencia: {{cantidad}}</p>
				<h5 class="card-text text-center">Costo: ${{precio}}</h5>
			</div>
			<div v-if="busqueda == 'true'">
					<button @click="seleccionar" class="btn btn-success w-100 text-white">Seleccionar</button>
			</div>
			<div v-else>
				<div class="flex justify-content-center">
					<button @click="verMas" class="btn btn-info w-100 text-white" data-bs-toggle="modal" data-bs-target="#verMas">Ver mas</button>
					<!-- <button @click="agregarCarrito" class="btn btn-success w-25"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-cart" viewBox="0 0 16 16">
					<path d="M0 1.5A.5.5 0 0 1 .5 1H2a.5.5 0 0 1 .485.379L2.89 3H14.5a.5.5 0 0 1 .491.592l-1.5 8A.5.5 0 0 1 13 12H4a.5.5 0 0 1-.491-.408L2.01 3.607 1.61 2H.5a.5.5 0 0 1-.5-.5zM3.102 4l1.313 7h8.17l1.313-7H3.102zM5 12a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm7 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm-7 1a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm7 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"/>
					</svg></button> -->
				</div>
			</div>
			<div v-if="estado === true" class="d-flex justify-content-between">
				<button @click="eliminar" class="btn btn-danger">
					<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-trash" viewBox="0 0 16 16">
						<path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z"/>
						<path fill-rule="evenodd" d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"/>
					</svg>
				</button>
				<button @click="modificar" class="btn btn-warning">Modificar</button>
				<button @click="add" class="btn btn-primary text-white" data-bs-toggle="modal" data-bs-target="#addproducto">+</button>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name:"ProductoComponent",
	props:[
		'nombre',
		'precio',
		'descripcion',
		'cantidad',
		'img',
		'etiquetas',
		'estado',
		'busqueda'
	],
	methods: {
		eliminar(){
			this.$emit("eliminar")
		},
		modificar(){
			this.$emit("modificar")
		},
		verMas(){
			this.$emit("verMas")
		},
		agregarCarrito(){
			this.$emit("agregarCarrito")
		},
		seleccionar(){
			this.$emit("seleccionar")
		},
		add(){
			this.$emit("add")
		}
	},
}
</script>

<style>
    
</style>